import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  background: #fff;
  padding: 0 30px;
`;

export const Content = styled.div`
  height: 64px;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    height: 38px;
  }

  aside {
    display: flex;
    align-items: center;
  }
`;

export const AdminPanel = styled(Link)`
  display: ${props => (props.isadmin === 'true' ? null : 'none')};

  margin-right: 20px;
  color: #fff;
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 14px;
  background: #59c17c;

  &:hover {
    animation: colors 5s infinite linear;
  }

  @keyframes colors {
    0% {
      background: #59c17c;
    }
    20% {
      background: #c15959;
    }
    40% {
      background: #b259c1;
    }
    60% {
      background: #596ac1;
    }
    80% {
      background: #59c1bb;
    }
    100% {
      background: #59c17c;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #eee;

  div {
    text-align: right;
    margin-right: 10px;

    strong {
      display: block;
      color: #333;
    }

    a {
      display: block;
      margin-top: 2px;
      font-size: 12px;
      color: #999;
    }
  }

  img {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    object-fit: cover;
  }
`;
